import React from "react";
// import { TbDragDrop2 } from "react-icons/tb";
import { Element } from "@craftjs/core";
import { CategoryCardTabList } from "components/CategoryCardTabList";
import Container from "components/general/Container";
import { Box } from "components/ui";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { PageText } from "./PageText";

export const PageExploreCatalogueTitle = ({ ...props }) => {
	let clonedChild = props.children.props.children[0];
	return (
		<Box style={{}} paddingVertical={24} alignItems="center">
			{clonedChild}
		</Box>
	);
};

export const PageExploreCatalogue = ({ ...props }) => {
	const isMobile = useIsMobile();
	return (
		<Box bg="$neutral25">
			<Container>
				<Box style={{ padding: isMobile ? 0 : 20 }} {...props}>
					<Element canvas id="text" is={PageExploreCatalogueTitle} data-cy="card-top">
						<PageText text="Explore Catalogue Title" fontSize={28} data-cy="catalogue-title" />
					</Element>
					<Box paddingHorizontal={isMobile ? 24 : "auto"}>
						<CategoryCardTabList isExploreCatalogue />
					</Box>
				</Box>
			</Container>
		</Box>
	);
};
